import { IUserInformation } from "Types/UserInformation";

import profileInformationStyles from "./profileInformation.module.scss";

type TInformation = {
  profileInformation: IUserInformation;
  className?: string;
};

export const ProfileInformation = ({
  profileInformation,
  className
}: TInformation): JSX.Element => {
  const { alias, name, lastname, description } = profileInformation;

  return (
    <div className={className}>
      <h1 className='alias'>{alias}</h1>
      <h2>{name}</h2>
      <h3>{lastname}</h3>
      <p className={profileInformationStyles.description}>{description}</p>
    </div>
  );
};
